export const EN = {
  "Trips": "New Trips",
  "USER_PROFILE": "User Profile",
  "USER_DETAILS": "User Details",
  "DETAILS": "Details",
  "CONTACT_DETAILS": "Contact Details",
  "ADDRESSES": "Addresses",
  "FIRST_NAME": "First Name",
  "LAST_NAME": "Last Name",
  "MIDDLE_INITIAL": "Middle Initial",
  "GENDER": "Gender",
  "DATE_OF_BIRTH": "Date of Birth",
  "AGE": "Age",
  "PRIMARY_LANGUAGE": "Primary Language",
  "PHONE_NUMBERS": "Phone Numbers",
  "HOME": "Home",
  "WORK": "Work",
  "EMAIL_ADDRESSES": "Email Addresses",
  "PHYSICAL_ADDRESSES": "Physical Address",
  "ADDRESS": "Address",
  "CITY": "City",
  "STATE": "State",
  "ZIP": "Zip",
  "MAILING_ADDRESS": "Mailing Address",
  "CURRENT_LANGUAGE": "English",
  "MONTH": "Month",
  "DAILY": "Daily",
  "DAY": "Day",
  "SAVE": "Save",
  "PREVIOUS_MONTH_LINK": "Previous {{ visibleTabs }} Months",
  "NEXT_MONTH_LINK": "Next {{ visibleTabs }} Months",
  "PREVIOUS_WEEK_LINK": "Previous {{ visibleDays }} Days",
  "NEXT_WEEK_LINK": "Next {{ visibleDays }} Days",
  "STATUS": "Status",
  "APPOINTMENT_TIME": "Appointment Time",
  "PICKUP_ADDRESS": "Pick Up Address",
  "PICKUP_TIME": " Pick Up Time",
  "DROPOFF_ADDRESS": "Drop Off Address",
  "PROVIDER_NAME": "Provider Name",
  "PROVIDER_PHONE": "Provider Number",
  "TRANSPORTATION_PROVIDER": "Transportation Provider",
  "ARRIVE_BY": "Arrive By",
  "DEPART_AFTER": "Depart After",
  "MEDICAL_FACILITY": "Medical Facility",
  "MEDICAL_NUMBER": "Medical Number",
  "TRIP_REASON": "Trip Reason",
  "MODE": "Mode",
  "TRIP_MILES": "Trip Miles",
  "TRIPS": "Trips",
  "TRIP_DETAILS": "Trip Details",
  "BACK": "Back",
  "MONTH_CALENDAR_DISABLED_TEXT":
    "MTM only displays 12 months in the past or 6 months in the future.",
  "NO_TRIPS": "No Trips Scheduled",
  "TRIPS_ON": "Trips on",
  "PENDING_ASSINGMENT": "Pending Assignment",
  "ACCOUNT_SETTINGS": "Account Settings",
  "HELP": "Help",
  "SIGNOUT": "Sign Out",
  "MENU_GMR": "Claim GMR Trip",
  "MENU_WMR": "Where's My Ride",
  "MENU_USERS": "Users",
  "MENU_SETUP": "Setup",
  "COMMUNICATION_PREFERENCES": "Communication Preferences",
  "EMAILS": "Emails",
  "TEXT_MESSAGES": "Text Messages",
  "PHONE_CALLS": "Phone Calls",
  "MEDICAL_HEALTH_PLAN": "Medical Health Plan",
  "PLAN_DETAILS": "Plan Details",
  "BENEFIT_GROUP": "Benefit Group",
  "HEALTH_PLAN_ID": "Health Plan ID",
  "MEDICAL_ID": "Medical ID",
  "EFFECTIVE_DATE": "Effective Date",
  "PERSON_COVERED": "Person Covered",
  "NAME": "Name",
  "PHONE": "Phone",
  "AUTOMATED_UPDATES_MESSAGE":
    "How would you like to receive automated updates about your ride?",
  "CANCEL_BTN": "Cancel",
  "BACK_BTN": "Back",
  "THIS_STOP_BTN": "Cancel Stop",
  "CANCEL_STOPS_MSG": "Which stop do you want to cancel?",
  "ALL_STOPS_BTN": "All Stops",
  "SUBMIT_BTN": "Submit",
  "CANCEL_SINGLE_WARNING_MSG":
    "Are you sure you want to cancel this ride? It cannot be undone once submit is clicked.",
  "CANCEL_MULTIPLE_WARNING_MSG":
    "Are you sure you want to cancel these rides? It cannot be undone once submit is clicked.",
  "SCHEDULED_PICKUP": "Scheduled Pickup",
  "SHOW_CANCELLED_TRIPS": "Show Cancelled Trips",
  "HEALTH_COVERAGE_DETAILS": "Health Coverage Details",
  "CANCEL_MORE_THAN_TWO_MSG":
    "For accuracy purposes, please contact MTM if you wish to cancel only part of this ride.",
  "CANCEL_ALL_BTN": "Cancel All Stops",
  "HEALTH_COVERAGE_TOOLTIP":
    "This information comes from your health plan. If it is incorrect contact your health plan to update it.",
  "MONTH_CALENDAR_ICON_TEXT": "Trips are scheduled for {{tripDate}}",
  "ARIA_DAILY_TAB": "Daily Tab",
  "ARIA_MONTHLY_TAB": "Monthly Tab",
  "ARIA_CANCEL_TRIP": "Cancel Trip",
  "ARIA_VIEW_TRIP_DETAILS": "View trip details",
  "ARIA_TRIPS_PAGE": "Trips page",
  "ALT_EDIT_CONTACT_DETAILS": "Edit contact details",
  "ALT_EDIT_COMM_PREFS": "Edit Communication preferences",
  "ALT_EDIT_ADDRESSES": "Edit Addresses",
  "SET_DEFAULT_LANGUAGE": "Set default language",
  "USER_MENU": "User Menu",
  "APPLICATIONS": "Apps",
  "LANGUAGE": "Language",
  "API_ERROR_MSG": "There was an problem. Please try again.",
  "YOUR_RIDE_ON": "Your ride on",
  "FROM": "from",
  "TO": "to",
  "ARRIVING_BY": "arriving by",
  "DEPARTING_AFTER": "departing after",
  "HAS_BEEN_CANCELLED": "has been cancelled",
  "SELECTED": "Selected",
  "TRIP": "Trip",
  "CANCEL_WARNING_TRIP":
    "Are you sure you want to cancel this ride? It cannot be undone once Yes is clicked",
  "CANCEL_WARNING_TRIPS":
    "Are you sure you want to cancel these rides? It cannot be undone once Yes is clicked",
  "MENU_REQUEST_RIDE": "Request a Ride",
  "REQUEST_RIDE_PAGE": "Request a Ride Page",
  "RAR_STEP_1_QUESTION": "What day do you need us to pick you up?",
  "APPOINTMENT_INFO_TITLE": "Appointment Information on",
  "WHERE_PICK_UP": "Where should we pick you up?",
  "WHAT_TIME_APPOINTMENT": "What time is your appointment?",
  "WHAT_TIME_PICKUP": "What time should we pick you up?",
  "WHERE_YOUR_DROPOFF": "Where should we drop you off?",
  "WHERE_YOUR_APPOINTMENT": "Where is your appointment?",
  "WHAT_REASON_APPOINTMENT": "What is the reason for your appointment?",
  "RAR_NEXT_BTN": "Next",
  "RAR_BACK_BTN": "Back",
  "ADD_STOP": "Add Stop",
  "APPOINTMENT": "Appointment",
  "WHAT_TIME": "What Time?",
  "WHERE_TO": "Where To?",
  "APPOINTMENT_REASON": "Appointment Reason?",
  "ADDITIONAL_PASSENGER": "Additional Passenger",
  "ADDITIONAL_PASSENGERS": "Additional Passengers",
  "ADD_PASSENGER": "Add Passenger",
  "PASSENGER_INFORMATION": "Passenger Information",
  "RELATIONSHIP": "Relationship",
  "DOES_PASSENGER_APPOINTMENT": "Does this passenger have an appointment?",
  "DOES_PASSENGER_WHEELCHAIR": "Does this passenger use a wheelchair?",
  "WHAT_TYPE_WHEELCHAIR": "What type of wheelchair do they use?",
  "WHAT_TYPE_WHEELCHAIR_YOU": "What type of wheelchair do you use?",
  "WHEELCHAIR_TYPE": "Wheelchair Type",
  "YES": "Yes",
  "NO": "No",
  "ADD_PASSENGER_SUB_TITLE":
    "Are there any additional passengers riding with you?",
  "RAR_INVALID_DATE_MSG":
    "To schedule a same day or next day ride, please contact MTM directly.",
  "RAR_NO_HEALTH_COVERAGE_MSG":
    "You are not eligible for a ride on the date selected",
  "PICKUP_LOCATION_NAME": "Pickup Location Name",
  "PICKUP_LOCATION_NUMBER": "Pickup Location Phone Number",
  "APPOINTMENT_LOCATION_NAME": "Appointment Location Name",
  "APPOINTMENT_LOCATION_NUMBER": "Appointment Location Phone Number",
  "PHONE_NUMBER": "phone number for this location",
  "LOCATION_NAME": "physician's name or facility name",
  "SN_TRANSFER": "Can you transfer?",
  "SN_WC_WEIGHT":
    "What is the combined total weight for you and your wheelchair?",
  "SN_ADD_WC": "Add Wheelchair",
  "SN": "Accommodations",
  "SN_USE_WHEELCHAIR": "Do you use a wheelchair?",
  "WHEELCHAIR_INFO": "Wheelchair Information",
  "WHAT_IS_MEDICAL_NUMBER": "What is the passenger's medical number?",
  "RAR_EXISTING_TRIP_WARNING":
    "Did you know you already have a trip requested that day? Do you need another ride?",
  "RAR_WILL_CALL": "I don't know a time",
  "RAR_MONTH_CALENDAR_WARNING_MSG":
    "Rides cannot be requested more than 6 months in advance. Please try again closer to your appointment.",
  "RAR_MULTI_COVERAGE_WARNING":
    "Which health plan are you using for this ride request?",
  "RAR_WILL_CALL_MSG_1":
    "By selecting this option you will have to contact MTM at",
  "RAR_WILL_CALL_MSG_2":
    "when you are ready to be picked up. It could take your driver up to one hour to arrive.",
  "RETURN_RIDE": "Return Ride",
  "DO_YOU_NEED_RIDE": "Do you need a Return Ride?",
  "ADD_RETURN_RIDE": "Add Return Ride",
  "RETURN_TIME": "Return Time",
  "ROUND_TRIP": "Round Trip on",
  "TRANSFER": "Transfer",
  "RIDE_REQUEST_SUMMARY": "Ride Request Summary",
  "WHEELCHAIR": "Wheelchair",
  "REASON": "Reason",
  "PICK_UP": "Pick Up",
  "DROP_OFF": "Drop Off",
  "RAR_MONTH_CALENDAR_PREV_MSG":
    "Only rides for future dates can be requested.",
  "RAR_MORE_TRIP_INFO_MSG": "More information on your trip",
  "CALL": "Call",
  "ADDRESS_NOT_FOUND":
    "The address entered cannot be found. Please enter a new address.",
  "RAR_PASSENGER_LIMIT_MSG":
    "Additional passengers are limited to 5. If you have more than 5 passengers, please call MTM directly at {{phoneNumber}}.",
  "CLEAR": "Clear",
  "CANCEL_STOP_ERROR_MSG":
    "Your cancellation was not successful. Please try again. If this persists, please contact MTM.",
  "RAR_TRIP_LIMIT_MSG":
    "Ride requests are limited to 5 appointments. If you require rides to more than 5 appointments, please call MTM directly at {{phoneNumber}}.",
  "RAR_REQUEST_SUCCESS_MSG":
    "Your ride request for {{appointmentDate}} has successfully been submitted to MTM.",
  "RAR_REQUEST_ERROR_MSG":
    "Your ride request was not successful. Please try again. If this persists, please contact MTM.",
  "RAR_INCOMPLETE_DATA_WARNING":
    "Are you sure you want to continue? The ride request has not been completed and all entered information will be lost.",
  "RAR_GENERIC_ERROR_MSG":
    "The request a ride function is currently having issues.  Please contact MTM directly if this persists.",
  "APPOINTMENT_INFORMATION": "Appointment Information",
  "DATE_SELECTION": "Date Selection",
  "SUMMARY": "Summary",
  "HEADER_HELP_MSG":
    "Need help? Give us a call and we'd be glad to assist you!",
  "RAR_ONE_WAY_TRIP": "One Way Trip on",
  "RAR_MULTI_STOP_TRIP": "Multi Stop Trip on",
  "WILL_CALL": "Will Call MTM",
  "COMMUNICATION_PREFERENCES_NONE": "Update your Contact Details phone numbers to be able to select a communication preference."
};
